import React from 'react';
import { ScrollReveal } from './shared';

const SectorFocusSection = () => {
  const sectors = [
    'Private Equity at Scale',
    'Healthcare / MedTech / Pharma',
    'Retail / Consumer / CPG',
    'Financial Services / Insurance',
    'Hospitality / Media / Entertainment',
    'Energy / Industrial',
  ];

  return (
    <section className="section-spacing bg-[#F1F5F9]" data-testid="sector-focus-section">
      <div className="container-luxury">
        <ScrollReveal>
          <div className="max-w-3xl mx-auto text-center mb-12">
            <p className="overline mb-4">Where We Focus</p>
            <h2 className="heading-section text-4xl sm:text-5xl text-[#0B1A2B] mb-6" data-testid="sector-headline">
              Areas of Focus
            </h2>
            <p className="body-large">
              APIG delivers the highest impact in sectors where deep expertise, predictive intelligence, and disciplined execution create measurable advantage.
            </p>
          </div>
        </ScrollReveal>

        <div className="flex flex-wrap justify-center gap-4 max-w-4xl mx-auto">
          {sectors.map((sector, index) => (
            <ScrollReveal key={index} delay={index * 80}>
              <div className="px-6 py-4 bg-white border border-[#E2E8F0] text-[#0B1A2B] text-sm font-medium tracking-wide" data-testid={`sector-tile-${index + 1}`}>
                {sector}
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SectorFocusSection;
